module.exports = __webpack_public_path__ + "static/media/rawkstars-active.a8197eae.svg";